import React from 'react';
import PropTypes from 'prop-types';

import { CustomDecimalRenderer } from '../numeralRenderers';

const BatchTaxEntriesAmountCellRenderer = ({ value }) => {
  if (value === null) {
    return <i style={{ fontStyle: 'italic' }}>Calculate</i>;
  }

  return <CustomDecimalRenderer value={value} />;
};

BatchTaxEntriesAmountCellRenderer.propTypes = {
  value: PropTypes.number,
};

export default BatchTaxEntriesAmountCellRenderer;
